/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlThreatName
 */
export interface ControlThreatName {
    /**
     * 
     * @type {string}
     * @memberof ControlThreatName
     */
    engine: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlThreatName
     */
    excluded: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlThreatName
     */
    matchedFileRiskRules?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlThreatName
     */
    name: string;
}

/**
 * Check if a given object implements the ControlThreatName interface.
 */
export function instanceOfControlThreatName(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "engine" in value;
    isInstance = isInstance && "excluded" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ControlThreatNameFromJSON(json: any): ControlThreatName {
    return ControlThreatNameFromJSONTyped(json, false);
}

export function ControlThreatNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlThreatName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'engine': json['engine'],
        'excluded': json['excluded'],
        'matchedFileRiskRules': !exists(json, 'matchedFileRiskRules') ? undefined : json['matchedFileRiskRules'],
        'name': json['name'],
    };
}

export function ControlThreatNameToJSON(value?: ControlThreatName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'engine': value.engine,
        'excluded': value.excluded,
        'matchedFileRiskRules': value.matchedFileRiskRules,
        'name': value.name,
    };
}

